import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { NgCircleProgressModule } from 'ng-circle-progress';

import { AffirmationsPageModule } from './affirmations/affirmations.module';
import { BookPageModule } from './book/book.module';
import { ExercicePageModule } from './exercice/exercice.module';
import { ImagesPageModule } from './images/images.module';
import { VisualizationPageModule } from './visualization/visualization.module';
import { MeditationPageModule } from './meditation/meditation.module';

import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';

import { Camera } from '@ionic-native/camera/ngx';
import { PhotoViewer } from '@ionic-native/photo-viewer/ngx';
// import { Facebook } from '@ionic-native/facebook/ngx';
import { Insomnia } from '@ionic-native/insomnia/ngx';
import { IonicStorageModule } from '@ionic/storage';

export const firebaseConfig = {
  apiKey: 'AIzaSyAPuyHNQMWwzj60XGmf0ygG54HhPrm4vKA',
  authDomain: 'miracle-morning-75ecc.firebaseapp.com',
  databaseURL: 'https://miracle-morning-75ecc.firebaseio.com',
  projectId: 'miracle-morning-75ecc',
  storageBucket: 'miracle-morning-75ecc.appspot.com',
  messagingSenderId: '477979814532'
};


@NgModule({
  declarations: [
    AppComponent
  ],
  entryComponents: [
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot({hardwareBackButton: false}),
    AppRoutingModule,
    FormsModule,
    NgCircleProgressModule.forRoot(),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AffirmationsPageModule,
    BookPageModule,
    ExercicePageModule,
    ImagesPageModule,
    VisualizationPageModule,
    MeditationPageModule,
    IonicStorageModule.forRoot()
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Camera,
    PhotoViewer,
    Insomnia,
    // Facebook,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
